import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ea8b23a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Есть 18?", -1))
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between","width":"100%","margin-top":"1em"} }

import ModalWindow from '@/components/UI/ModalWindow.vue';
    import ButtonCustom from '@/components/UI/ButtonCustom.vue';

    import type { Ref } from 'vue'
    import { computed, ref} from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AgeChecker',
  emits: ['close'],
  setup(__props, { emit }) {

    

    let showModal = ref(!JSON.parse(localStorage.getItem('verifyAge')))

    function ageVerified(verify :boolean){
        if(verify){
            localStorage.setItem('verifyAge', JSON.stringify(true))
            showModal.value = false
        } else {
          let cartoonsArr = [
            'https://www.youtube.com/watch?v=tPiagp9t5is',
            'https://www.youtube.com/watch?v=31OMkbOwdtM',
            'https://www.youtube.com/watch?v=vLeAkrd_kG8',
            'https://www.youtube.com/watch?v=V8Er1uk4fcw',
            'https://www.youtube.com/watch?v=TLpFz3OQe4g',
            'https://www.youtube.com/watch?v=LU3O3YE88bg',
            'https://www.youtube.com/watch?v=M2or_zdYA7g'
          ]
          window.location.href = cartoonsArr[Math.floor(Math.random() * (0 + cartoonsArr.length))];
        }
    }

return (_ctx: any,_cache: any) => {
  return (_unref(showModal))
    ? (_openBlock(), _createBlock(ModalWindow, {
        key: 0,
        showbtn: false,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_isRef(showModal) //@ts-ignore
 ? showModal.value = false : showModal = false))
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("p", _hoisted_2, [
            _createVNode(ButtonCustom, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (ageVerified(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Да")
              ]),
              _: 1
            }),
            _createVNode(ButtonCustom, {
              style: {"margin-left":"0.5em"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (ageVerified(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Нет")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})